export default "__VITE_ASSET__DQ9SAYUM__"